module.exports = __webpack_public_path__ + "static/img/person.bf6db797.svg";